import styled, { css } from 'styled-components';
import background from '@/media/onboarding/sitebuilder-v2/bg-gradient.svg';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    font-family: ${theme.v2.font.family.primary};
    padding-bottom: 96px;
    width: 100%;
    
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      position: relative;
    }
  `}
`;

export const WaveTop = styled.div`
  ${({ theme }) => css`
    background: url(${background}) no-repeat center top;
    background-size: 100% 290px;
    height: 290px;
    overflow: hidden;
    position: absolute;
    top: 0;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      background-size: 100% 110px;
      height: 110px;
    }
  `};
`;

export const CirclesImage = styled.img`
  ${({ theme }) => css`
    height: 320px;
    right: 5vw;
    position: absolute;
    top: -181px;
    user-select: none;
    z-index: 1;
    -webkit-user-drag: none;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 200px;
      top: -60px;
      right: -60px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: 86px;
      right: 10px;
      top: -40px;
    }
  `}
`;

export const StarImage = styled.img`
  ${({ theme }) => css`
    height: 400px;
    top: -256px;
    position: absolute;
    left: -3vw;
    user-select: none;
    z-index: 1;
    -webkit-user-drag: none;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 200px;
      left: -40px;
      top: 40px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: 104px;
      top: -40px;
    }
  `};
`;

export const InnerContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 173px auto 0;
    max-width: 1180px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 90px auto 0;
      padding: 0 20px;
    }
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.extraDark};
    font-size: ${theme.v2.font.sizes.lg};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    margin: 0 0 27px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
      max-width: 320px;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 37px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 24px;
    }
  `}
`;

export const CardSite = styled.div`
  ${({ theme }) => css`
    flex: 1;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const CardAgent = styled.div`
  ${({ theme }) => css`
    width: 715px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const Card = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    border: 1px solid ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 24px;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, .08);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 32px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 32px 20px;
    }
  `}
`;

export const CardRow = styled.div`
  display: flex;
  gap: 51px;
`;

export const CardColumn = styled.div``;

export const CardColumnImage = styled.div`
  ${({ theme }) => css`
    padding-right: 13px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const CardHeader = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    gap: 16px;
    margin-bottom: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 8px;
    }
  `}
`;

export const CardIcon = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.brand.primaryLowLight};
    border-radius: 50%;
    display: flex;
    height: 48px;
    justify-content: center;
    width: 48px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 32px;
      width: 32px;
    }
  `}
`;

export const CardTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryDark};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const CardText = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: 1.5;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      text-align: center;
    }
  `}
`;

export const TextPolicy = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    line-height: 1.5;
    margin-top: 90px;

    a {
      font-size: ${theme.v2.font.sizes.xxs};
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin-top: 24px;
      text-align: center;
    }
  `}
`;

export const CardButtonSite = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    margin-top: auto;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin-top: 24px;
    }
  `}
`;

export const WrapperSwitch = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const TextSwitch = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    line-height: 1.5;
  `}
`;

export const CardButtonAgent = styled.div`
  ${({ theme }) => css`
  align-items: center;
    display: flex;
    gap: 24px;
    margin-top: 40px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 14px;
    }
  `}
`;

export const AiChatImage = styled.img`
  border-radius: 10px 10px 24px 24px;
  box-shadow: 0 8.963px 14.938px 0 rgba(223, 226, 235, 0.28), 0 5.975px 11.95px 0 rgba(223, 226, 235, 0.22);
`;

export const SwitchWrapper = styled.div``;

export const Switch = styled.div`
  ${({ theme, active }) => css`
    background: ${active ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.neutral.highDark};
    border-radius: 12px;
    cursor: pointer;
    display: flex;
    height: 24px;
    position: relative;
    width: 44px;
  `}
`;

export const SwitchDot = styled.div`
  ${({ theme, active }) => css`
    background: ${theme.v2.colors.white.primary};
    border-radius: 50%;
    display: flex;
    height: 16px;
    left: ${active ? '24px' : '4px'};
    position: absolute;
    top: 4px;
    width: 16px;
    transition: all 0.2s ease-in-out;
  `}
`;
